import { utils } from "../../Foundation";
export class PIMImage {

    constructor(element) {
        this._refs = {
            el: element,
            pimSettings: {
                url: `${window.location.origin}/api/pim/getColorImageAssets`,
                filetype: 'psd'
            }
        }

        this._init();
    }

    _init() {

        var el = this._refs.el;
        var model = el.getAttribute("data-model");
        var color = el.getAttribute("data-color");
        var size = el.getAttribute("data-size");

        var imageElem = el.getElementsByTagName("img")[0];
        if (model && color) {
            var loadingHTML = utils.createElement("div", {
                class: "loading_animation"
            });
            var progress_animation = utils.createElement("div", {
                class: "progress_animation",
                role: "alert",
                "aria-busy": "true",
                "aria-live": "polite"
            });
            var eva = utils.createElement("i", {
                class: "eva eva-loader-outline",
                "aria-hidden": "true",
            });


            progress_animation.append(eva)
            loadingHTML.append(progress_animation)
            el.prepend(loadingHTML);
            this._fetchPimImage(model, color, (pimData) => {
                this._setProductImage(imageElem, pimData, size, loadingHTML);
            })
        }
    }


    _setProductImage(imageElem, pimData, size, loaderElement) {
        const addProductImage = (newImageUrl) => {
            imageElem.src = newImageUrl;
        }

        const removeLoadingAnimation = () => {
             loaderElement.remove();
        }

        const productImage = this._getProductImage(pimData, size);
        if (productImage) {
            addProductImage(productImage)
        }
        removeLoadingAnimation()
    }


    _fetchPimImage(model, color, cb) {
        try {
            if (!color) {
                return cb({});
            }
            fetch(`${this._refs.pimSettings.url}/${model}?filetype=${this._refs.pimSettings.filetype}&color=${color}&primary=true`)
                .then(response => {
                    return response.json().then(data => {
                        return ({ status: response.status, payload: data, color })
                    })
                })
                .then(data => cb(data))
                .catch(err => cb({ err }));
        } catch (err) {
            return cb({ "status": 500, "payload": err });
        }
    }

    _getProductImage(pimData, size) {
        // Check if pim data includes image
        if (pimData?.status === 200) {
            const primaryImage = pimData.payload[0]?.ThumbnailUrls["thumbnail" + size] || pimData.payload[0]?.Path;
            // Get first product image from pim
            return primaryImage;
        }
        return null;
    }
}